import clsx from 'clsx';

import IconCheck from '@ui/components/icons/IconCheck';
import IconError from '@ui/components/icons/IconError';

export interface NotificationTextProps {
  text: string;
  className?: string;
  type?: 'info' | 'error' | 'share';
}

const Notification = ({
  text,
  className,
  type = 'info',
}: NotificationTextProps) => (
  <div
    className={clsx(
      'relative flex w-full items-center justify-center rounded-[40px] px-6 py-12 lg:px-[60px]',
      type === 'info' && 'bg-notification',
      type === 'error' && 'bg-notification-error',
    )}
  >
    {type === 'info' && (
      <IconCheck className="mr-4 min-w-[22px] fill-brand-white-100" />
    )}
    {type === 'error' && (
      <IconError className="mr-4 min-w-[26px] fill-brand-white-100" />
    )}
    <p
      className={clsx(
        'text-[24px]/[34px] font-semibold text-brand-white-100',
        className,
      )}
    >
      {text}
    </p>
  </div>
);

export default Notification;
